import { AiChatPanel } from "./ai-chat-panel";
import { useDarwinAccess } from "./use-darwin-access";

export function DarwinAI() {
    const canUseDarwin = useDarwinAccess();

    if (!canUseDarwin) return null;

    return <AiChatPanel />;
}
